import {MarkerIconPath, MarkerTypes} from '../constants/general'

class MarkerModel {
    //This class is just a convient way to create error free markers.
    constructor(id, type = MarkerTypes.NORMAL, options){
        this.id = id
        this.type = type
        this.options = options
    }
}

export default MarkerModel